import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, DOCUMENT } from '@angular/core';

@Component({
    selector: 'app-pks-bursa-bm',
    templateUrl: './pks-bursa-bm.component.html',
    styleUrls: ['./pks-bursa-bm.component.scss'],
    standalone: false
})
export class PksBursaBmComponent {
  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: Object,
  ) {}

  scrollToRoadmap() {
    if (!isPlatformBrowser(this.platformId)) return;

    const target = this.document.getElementById('pks-bursa-roadmap');
    if (!target) return;

    const headerOffset = 100;
    const y = target.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}
